<template>
    <div>
        <button v-if="withButton" type="button" :class="classButton" data-bs-toggle="modal" :data-bs-target="'#' + modalId">{{buttonTitle}}</button>

        <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-title-pink">
                        <p class="modal-title">{{modalTitle}}</p>
                        <a class="close" @click="cancel">
                            <span aria-hidden="true">&times;</span>
                        </a>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .close {
        text-decoration: none;
        color: #424141;
        cursor: pointer;
    }
</style>
<script>
export default {
    name: 'Modal',
    props: {
        modalId: String,
        withButton: {
            type: Boolean,
            default: false,
        },
        buttonTitle: String,
        modalTitle: String,
        classButton: String,
    },
    methods: {
        cancel() {
            $('#' + this.modalId).modal('toggle');
        },
    },
};
</script>
